// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dPPg7Yn8HK83Bej_2lOJ{border-bottom:1px solid rgba(30,12,27,.25);color:var(--theme-page-text-color);font-family:Rubik,"sans-serif";font-size:18px;font-stretch:normal;font-style:normal;font-weight:500;letter-spacing:normal;line-height:1.25;margin-bottom:12px;padding-bottom:6px;width:100%}.u9Z4GgwNsIZMqIjZ1jG_{display:flex;overflow:auto;position:relative;scrollbar-width:none}.u9Z4GgwNsIZMqIjZ1jG_::-webkit-scrollbar{display:none}.I8ZkYxiBFbknlyQGkj14{display:grid;margin:0 5px 20px 5px;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `dPPg7Yn8HK83Bej_2lOJ`,
	"itemsWrapper": `u9Z4GgwNsIZMqIjZ1jG_`,
	"wrapper": `I8ZkYxiBFbknlyQGkj14`
};
export default ___CSS_LOADER_EXPORT___;
